import { useCallback, useEffect, useState } from 'react';
import copier from 'copy-to-clipboard';

const clipboardService = {
  async copy(text: string) {
    return new Promise((resolve) => {
      copier(text);
      resolve(text);
    });
  },
};

interface UseCopyToClipboard {
  copied: boolean;
  copyToClipboard: (text: string) => void;
}

export const useCopyToClipboard = (): UseCopyToClipboard => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied, setCopied]);

  const copyToClipboard = useCallback((text: string) => {
    clipboardService.copy(text);
    setCopied(true);
  }, []);

  return {
    copied,
    copyToClipboard,
  };
};
